// ABOUTME: Opens the iJewel 3D viewer for a product in a dialog when the customer clicks "View in 3D".
// ABOUTME: The viewer scripts and the model load only on the first click, because together they weigh tens of megabytes.

const WEBGI_URL = 'https://releases.ijewel3d.com/libs/webgi-v0/bundle-0.22.0.js';
const MINI_VIEWER_URL = 'https://releases.ijewel3d.com/libs/mini-viewer/0.6.18/bundle.nowebgi.iife.js';
const DRIVE_BASENAME = 'drive';

const loadScript = (src) => new Promise((resolve, reject) => {
  const script = document.createElement('script');

  script.src = src;
  script.addEventListener('load', resolve);
  script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)));
  document.head.appendChild(script);
});

let viewerLibrary;

// The mini viewer bundle expects WebGI to be loaded first.
const loadViewerLibrary = () => {
  viewerLibrary ??= loadScript(WEBGI_URL).then(() => loadScript(MINI_VIEWER_URL));

  return viewerLibrary;
};

if (!customElements.get('product-3d-viewer')) {
  customElements.define('product-3d-viewer', class Product3dViewer extends HTMLElement {
    #dialog;
    #stage;
    #loadingStatus;
    #errorStatus;
    #started = false;

    connectedCallback() {
      this.#dialog = this.querySelector('.product-3d-viewer__dialog');
      this.#stage = this.querySelector('.product-3d-viewer__stage');
      this.#loadingStatus = this.querySelector('.product-3d-viewer__status:not(.product-3d-viewer__status--error)');
      this.#errorStatus = this.querySelector('.product-3d-viewer__status--error');

      this.querySelector('.product-3d-viewer__open').addEventListener('click', () => this.#open());
      this.querySelector('.product-3d-viewer__close').addEventListener('click', () => this.#dialog.close());
      this.#dialog.addEventListener('click', (event) => {
        if (event.target === this.#dialog) {
          this.#dialog.close();
        }
      });

      // The dialog sits inside the gallery slider, so a drag that rotates the model must not reach the slider.
      for (const type of ['pointerdown', 'mousedown', 'touchstart']) {
        this.#dialog.addEventListener(type, (event) => event.stopPropagation(), { passive: true });
      }
    }

    #open() {
      this.#dialog.showModal();

      if (!this.#started) {
        this.#started = true;
        this.#start();
      }
    }

    async #start() {
      window.addEventListener('ijewel-scene-ready', () => {
        this.#loadingStatus.hidden = true;
      }, { once: true });

      try {
        await loadViewerLibrary();
        await window.ijewelViewer.loadModelById(this.dataset.modelId, DRIVE_BASENAME, this.#stage, {
          showCard: false,
          showConfigurator: false
        });
      } catch (error) {
        this.#loadingStatus.hidden = true;
        this.#errorStatus.hidden = false;
        throw error;
      }
    }
  });
}
